module.exports = __webpack_public_path__ + "static/phone-white-spanish-77bec2ec4f3432fbf5ca7ce8983056e1.gif";